import { createIconComponent } from '../../factory/create-icon-component';
export const ParametersIcon = createIconComponent(
  'ParametersIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.13783 2.43114C10.1873 1.90642 10.712 1.64405 11.2624 1.54079C11.7499 1.44933 12.2501 1.44933 12.7376 1.54079C13.288 1.64405 13.8127 1.90642 14.8622 2.43114L18.2757 4.1379C20.1181 5.05911 21.0393 5.51972 21.3349 6.14301C21.5922 6.68542 21.5922 7.3147 21.3349 7.85711C21.0393 8.48041 20.1181 8.94101 18.2757 9.86223L14.8622 11.569C13.8127 12.0937 13.288 12.3561 12.7376 12.4593C12.2501 12.5508 11.7499 12.5508 11.2624 12.4593C10.712 12.3561 10.1873 12.0937 9.13783 11.569L5.72433 9.86223C3.88191 8.94101 2.96069 8.48041 2.66508 7.85711C2.40782 7.3147 2.40782 6.68542 2.66508 6.14301C2.96069 5.51972 3.88191 5.05911 5.72433 4.13789L9.13783 2.43114Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 13.0001L16.2933 15.8534C14.7191 16.6405 13.932 17.0341 13.1064 17.189C12.3752 17.3262 11.6248 17.3262 10.8936 17.189C10.068 17.0341 9.28094 16.6405 7.70675 15.8534L2 13.0001"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 18.0001L16.2933 20.8534C14.7191 21.6405 13.932 22.0341 13.1064 22.189C12.3752 22.3262 11.6248 22.3262 10.8936 22.189C10.068 22.0341 9.28094 21.6405 7.70675 20.8534L2 18.0001"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
